import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { analyzeSentiment } from '../../lib/openai';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiMessageSquare, FiLoader } = FiIcons;

function FeedbackAnalyzer() {
  const [feedback, setFeedback] = useState('');
  const [analysis, setAnalysis] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const analyzeFeedback = async () => {
    if (!feedback.trim()) return;
    
    setIsLoading(true);
    try {
      const result = await analyzeSentiment(feedback);
      setAnalysis(result);
    } catch (error) {
      console.error('Error analyzing feedback:', error);
      setAnalysis('Failed to analyze feedback. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <SafeIcon icon={FiMessageSquare} className="w-5 h-5 mr-2 text-primary-500" />
        Customer Feedback Analyzer
      </h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Customer Feedback
          </label>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Paste customer feedback or comments here..."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            rows={4}
          />
        </div>
        
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={analyzeFeedback}
          disabled={isLoading || !feedback.trim()}
          className="w-full bg-primary-600 text-white py-2 rounded-lg font-medium hover:bg-primary-700 transition-colors flex items-center justify-center space-x-2 disabled:opacity-50"
        >
          {isLoading ? (
            <>
              <SafeIcon icon={FiLoader} className="w-4 h-4 animate-spin" />
              <span>Analyzing...</span>
            </>
          ) : (
            <>
              <SafeIcon icon={FiMessageSquare} className="w-4 h-4" />
              <span>Analyze Sentiment</span>
            </>
          )}
        </motion.button>
        
        {analysis && (
          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
            <h4 className="font-medium text-gray-900 mb-2">Analysis</h4>
            <p className="text-sm whitespace-pre-wrap">{analysis}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default FeedbackAnalyzer;